export enum ERuntimeSettings {
  /** Манифест виджета авторизации **/
  loginWidgetManifest = 'loginWidgetB2CManifest',
  /** Манифест виджета калькулятора **/
  offerCalculatorManifest = 'offerCalculatorManifest',
  /** Дефолтный стейт калькулятора **/
  calculatorInitialValues = 'mortgage-promo-frontend.calculatorInitialValues',

  /** Фичатогл включения сео-данных **/
  isSeoDataEnabled = 'mortgage-promo-frontend.isSeoData.Enabled',

  /** Фичатогл включения продукта Ипотека **/
  isMortgageRedirectEnabled = 'mortgage-broker-calculator.IsMortgageRedirect.Enabled',

  /* PLATFORM */
  projectName = 'projectName',
  initialState = 'initialState',
  applicationContextCustom = 'applicationContext.custom',
  soprApiBaseUrl = 'soprApi.browserUrl',
  isWebView = 'web.isWebView',
  refinBannerEnabled = 'mortgage-promo-frontend.refinLeadBanner.Enabled',
  isSeoCrossLinksEnabled = 'mortgage-promo-frontend.isSeoCrosslinks.Enabled',
  /** Фичатогл режима shadow (красный фон, запросы с X-ShadowMode) **/
  isShadowMode = 'mortgage-promo-frontend.isShadowMode.Enabled',
  /** Фичатогл включения системной темы для мобильных устройств **/
  uiKitSystemThemeEnabledMobile = 'ui-kit.system-theme-enabled.mobile',
}
